export default {
    getVideoDetails:null,
    acceptVideoCallDetails:null,
    conferenceId:null,
    videoLoadingStatus:false,
    guestUser:null
}